
import {translate} from '@elements/translations';
import {ref, defineComponent, watch} from 'vue';
import { storeToRefs } from 'pinia'
import { useTicketStore } from '../../stores/TicketStore';
import { useActivityStore } from '../../stores/ActivityStore';
import Select from "../form-elements/Select.vue";
import { convertInCurrency } from "../../utils/utils";

export default defineComponent({
    name: 'ModalFooter',
    props: {
        stepViews: {
            type: Array,
            required: true
        },
        step: {
            type: Number,
            required: true
        },
        type: {
            type: String,
            required: false,
            default: "ticket"
        },
    },
    components: {
        Select
    },
    setup(props, {emit}) {
        const isActivity = props.type === "activity";
        const ticketStore = isActivity ? useActivityStore() : useTicketStore();

        const {
            step,
            selectedCurrency,
            ticketConfigurations,
            stepValidation,
        } = storeToRefs(ticketStore);
        const {changeStep, changeCurrency } = ticketStore;
        const currencyOptions = ref<object>([
            {value: 'EUR', label: 'EUR'},
            {value: 'USD', label: 'USD'},
            {value: 'CHF', label: 'CHF'},
        ]);
        const showErrorMessage = ref(false);
        const errorMessage = ref("");
        const isMobile = matchMedia('(max-width: 767px)').matches;

        const onChangeStep = (step: number) => {
            if(stepValidation.value.isValid()) {
                if(step === props.stepViews.length) {
                    emit('addToCart');
                    changeStep(step);
                    showErrorMessage.value = false;
                } else {
                    changeStep(step);
                    showErrorMessage.value = false;
                }
            } else {
                showErrorMessage.value = true;
                errorMessage.value = stepValidation.value.validationError;
            }
        };

        watch(() => stepValidation.value, function() {
            if(stepValidation.value.isValid()) {
                errorMessage.value = "";
            } else {
                errorMessage.value = stepValidation.value.validationError;
            }
        });

        const onChangeCurrency = (option) => {
            changeCurrency(option);
        }

        const goBack = () => {
            if(step.value > 0) {
                changeStep(step.value - 1);
            } else {
                emit('closeModal', true);
            }
        };

        return {
            step,
            translate,
            onChangeStep,
            currencyOptions,
            onChangeCurrency,
            selectedCurrency,
            ticketConfigurations,
            errorMessage,
            showErrorMessage,
            isMobile,
            goBack,
            stepValidation,
            convertInCurrency
        };
    }
})
;
